import CardSpendingLimits from './CardSpendingLimits';

export default CardSpendingLimits;
